import DesignTokens from '@tableau/design-tokens';
import { ArrowTriangleDownIconRaw } from '@tableau/icons/ArrowTriangleDownIcon/raw';
import { ArrowTriangleLeftIconRaw } from '@tableau/icons/ArrowTriangleLeftIcon/raw';
import { ArrowTriangleRightIconRaw } from '@tableau/icons/ArrowTriangleRightIcon/raw';
import { CalendarBaseIconRaw } from '@tableau/icons/CalendarBaseIcon/raw';
import { DatasourceCanBaseIconRaw } from '@tableau/icons/DatasourceCanBaseIcon/raw';
import { DatasourceCanEmbeddedIconRaw } from '@tableau/icons/DatasourceCanEmbeddedIcon/raw';
import { DatasourceServerConnectionBaseIconRaw } from '@tableau/icons/DatasourceServerConnectionBaseIcon/raw';
import { DownloadBaseIconRaw } from '@tableau/icons/DownloadBaseIcon/raw';
import { FieldRenameIconRaw } from '@tableau/icons/FieldRenameIcon/raw';
import { FileBaseIconRaw } from '@tableau/icons/FileBaseIcon/raw';
import { FilePdfPaperclipIconRaw } from '@tableau/icons/FilePdfPaperclipIcon/raw';
import { FlowBaseIconRaw } from '@tableau/icons/FlowBaseIcon/raw';
import { LockSolidIconRaw } from '@tableau/icons/LockSolidIcon/raw';
import { LockUnlockedOutlineIconRaw } from '@tableau/icons/LockUnlockedOutlineIcon/raw';
import { MoreDotsIconRaw } from '@tableau/icons/MoreDotsIcon/raw';
import { NotificationAlertErrorShieldSolidIconRaw } from '@tableau/icons/NotificationAlertErrorShieldSolidIcon/raw';
import { NotificationAlertLowShieldOutlineBaseIconRaw } from '@tableau/icons/NotificationAlertLowShieldOutlineBaseIcon/raw';
import { NotificationAlertLowShieldOutlinePauseIconRaw } from '@tableau/icons/NotificationAlertLowShieldOutlinePauseIcon/raw';
import { NotificationAlertWarningShieldSolidIconRaw } from '@tableau/icons/NotificationAlertWarningShieldSolidIcon/raw';
import { NotificationCheckIconRaw } from '@tableau/icons/NotificationCheckIcon/raw';
import { NotificationInfoOutlineIconRaw } from '@tableau/icons/NotificationInfoOutlineIcon/raw';
import { PencilBaseIconRaw } from '@tableau/icons/PencilBaseIcon/raw';
import { PlayCircleIconRaw } from '@tableau/icons/PlayCircleIcon/raw';
import { ReactiveRawIconRegistry } from '@tableau/icons/reactive';
import { ShieldBaseIconRaw } from '@tableau/icons/ShieldBaseIcon/raw';
import { SitesBaseIconRaw } from '@tableau/icons/SitesBaseIcon/raw';
import { StatusActiveIconRaw } from '@tableau/icons/StatusActiveIcon/raw';
import { StatusDownIconRaw } from '@tableau/icons/StatusDownIcon/raw';
import { StatusErrorIconRaw } from '@tableau/icons/StatusErrorIcon/raw';
import { StatusInProgressIconRaw } from '@tableau/icons/StatusInProgressIcon/raw';
import { StatusRefreshIconRaw } from '@tableau/icons/StatusRefreshIcon/raw';
import { TableauFileViewBaseIconRaw } from '@tableau/icons/TableauFileViewBaseIcon/raw';
import { TableauFileViewPaperclipIconRaw } from '@tableau/icons/TableauFileViewPaperclipIcon/raw';
import { TableauFileWorkbookBaseIconRaw } from '@tableau/icons/TableauFileWorkbookBaseIcon/raw';
import { TableauFileWorkbookNewIconRaw } from '@tableau/icons/TableauFileWorkbookNewIcon/raw';
import { TableauFileWorkbookPaperclipIconRaw } from '@tableau/icons/TableauFileWorkbookPaperclipIcon/raw';
import { UserSingleBaseIconRaw } from '@tableau/icons/UserSingleBaseIcon/raw';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-icon-spinner', {
    display: 'inline-block',
    backgroundImage: 'url(img/busy.gif?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    width: '10px',
    height: '10px',
});

cssRule('.tb-icon-spinner-large, .tb-icon-spinner-large-alternate', {
    display: 'inline-block',
    backgroundImage: 'url(img/busy_large.gif?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    width: '32px',
    height: '32px',
});

cssRule('.tb-icon-spinner-large-alternate', {
    backgroundImage: 'url(img/busy_alternate_large.gif?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-loading-indicator', {
    backgroundImage: 'url(img/busy_large.gif?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    width: '32px',
    height: '32px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: '-16px',
    marginTop: '-16px',
});

cssRule('.tb-icon-alert', {
    backgroundRepeat: 'no-repeat',
    width: '19px',
    height: '19px',
    display: 'inline-block',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationAlertErrorShieldSolidIconRaw, 18)})`,
});

cssRule('.tb-icon-alert-list-header', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationAlertLowShieldOutlineBaseIconRaw, 18)})`,
    display: 'inline-block',
    backgroundRepeat: 'no-repeat',
    width: '19px',
    height: '19px',
});

cssRule('.tb-icon-server-alert-list-suspended', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationAlertLowShieldOutlinePauseIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
    display: 'inline-block',
    backgroundRepeat: 'no-repeat',
    width: '19px',
    height: '19px',
});

cssRule('.tb-icon-server-alert-list-suspended:hover', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationAlertLowShieldOutlinePauseIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#000000'))})`,
});

cssRule('.tb-icon-server-alert-list-suspended-active', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationAlertLowShieldOutlinePauseIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#000000'))})`,
    display: 'inline-block',
    backgroundRepeat: 'no-repeat',
    width: '19px',
    height: '19px',
});

cssRule('.tb-icon-dialogs-status-alert', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationAlertErrorShieldSolidIconRaw, 18)})`,
    display: 'inline-block',
    backgroundRepeat: 'no-repeat',
    width: '19px',
    height: '19px',
});

cssRule('.tb-icon-dialogs-status-alert-active', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationAlertErrorShieldSolidIconRaw, 18)})`,
    display: 'inline-block',
    backgroundRepeat: 'no-repeat',
    width: '19px',
    height: '19px',
});

cssRule('.tb-popup-menu:focus .tb-icon-help-menu', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationInfoOutlineIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
});

cssRule('.tb-popup-menu:focus .tb-action-icon', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(MoreDotsIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#333333'))})`,
});

cssRule('.tb-popup-menu', {
    position: 'relative',
});

cssRule('.tb-popup-menu:focus', {
    outline: 0,
});

cssRule('.tb-popup-menu.tb-popup-menu-inline', {
    display: 'inline-block',
});

cssRule('.tb-popup-menu.tb-popup-menu-inline >div', {
    display: 'inline-block',
});

cssRule('.tb-popup-menu:focus .tb-popup-menu-button', {
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.hover, '#666'),
});

cssRule('.tb-popup-menu:focus .tb-popup-menu-button >.tb-text', {
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-popup-menu:focus .tb-popup-menu-button >.tb-line', {
    backgroundColor: applyColor(DesignTokens.color.elevation.border.default.subtle, '#666'),
});

cssRule('.tb-popup-menu:focus .tb-popup-menu-button >.tb-arrow', {
    background: `var(${ReactiveRawIconRegistry.register(ArrowTriangleDownIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#333333'))}) no-repeat`,
});

cssRule('.tb-popup-menu', {
    position: 'relative',
});

cssRule('.tb-popup-menu:focus', {
    outline: 0,
});

cssRule('.tb-popup-menu.tb-popup-menu-inline', {
    display: 'inline-block',
});

cssRule('.tb-popup-menu.tb-popup-menu-inline >div', {
    display: 'inline-block',
});

cssRule('.tb-popup-menu:focus .tb-popup-menu-button', {
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.hover, '#666'),
});

cssRule('.tb-popup-menu:focus .tb-popup-menu-button >.tb-text', {
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-popup-menu:focus .tb-popup-menu-button >.tb-line', {
    backgroundColor: applyColor(DesignTokens.color.elevation.border.default.subtle, '#666'),
});

cssRule('.tb-popup-menu:focus .tb-popup-menu-button >.tb-arrow', {
    background: `var(${ReactiveRawIconRegistry.register(ArrowTriangleDownIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#333333'))}) no-repeat`,
});

cssRule('.tb-action-icon', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(MoreDotsIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
    backgroundSize: '19px 19px',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    width: '37px',
    height: '37px',
    cursor: 'pointer',
});

cssRule('.tb-action-icon:hover', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(MoreDotsIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#333333'))})`,
});

cssRule('.tb-action-icon-svg', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(MoreDotsIconRaw, 18, applyColor(DesignTokens.color.icon.default.light, '#FFFFFF'))})`,
    backgroundSize: 'contain',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    cursor: 'pointer',
});

cssRule('.tb-drop-down-icon', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(ArrowTriangleDownIconRaw, 12, applyColor(DesignTokens.color.icon.default.default, '#666666'))})`,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    width: '19px',
    height: '19px',
    cursor: 'pointer',
});

cssRule('.tb-icon-help', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '17px',
    height: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationInfoOutlineIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
    backgroundSize: '19px 19px',
});

cssRule('.tb-icon-help:hover', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationInfoOutlineIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#333333'))})`,
});

cssRule('.tb-icon-info', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '17px',
    height: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '19px 19px',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationInfoOutlineIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
});

cssRule('.tb-icon-info:hover', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationInfoOutlineIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#333333'))})`,
});

cssRule('.tb-icon-info-no-hover', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '17px',
    height: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '19px 19px',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationInfoOutlineIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
});

cssRule('.tb-icon-permissions-info', {
    display: 'table-cell',
    verticalAlign: 'bottom',
    width: '17px',
    height: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationInfoOutlineIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
});

cssRule('.tb-icon-project-permissions-info', {
    display: 'inline-block',
    verticalAlign: 'text-bottom',
    marginLeft: '3px',
    width: '17px',
    height: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationInfoOutlineIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
    backgroundSize: '19px 19px',
});

cssRule('.tb-icon-project-permissions-info:hover', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationInfoOutlineIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#333333'))})`,
});

cssRule('.tb-icon-checkmark', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationCheckIconRaw, 14, applyColor(DesignTokens.color.icon.default.default, '#666666'))})`,
    width: '17px',
    height: '17px',
    backgroundRepeat: 'no-repeat',
    display: 'inline-block',
});

cssRule('.tb-place-action-icon', {
    boxSizing: 'border-box',
    height: '31px',
    width: '31px',
    backgroundSize: '19px 19px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    padding: '6px',
});

cssRule('.tb-place-action-icon:hover', {
    padding: 0,
});

cssRule('.tb-new-workbook-icon', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(TableauFileWorkbookNewIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
});

cssRule('.tb-new-workbook-icon:hover, .tb-new-workbook-icon:focus', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(TableauFileWorkbookNewIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#333333'))})`,
});

cssRule('.tb-edit-workbook-icon', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(PencilBaseIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
});

cssRule('.tb-edit-workbook-icon:hover, .tb-edit-workbook-icon:focus', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(PencilBaseIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#333333'))})`,
});

cssRule('.tb-download-icon', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(DownloadBaseIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
});

cssRule('.tb-download-icon:hover, .tb-download-icon:focus', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(DownloadBaseIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#333333'))})`,
});

cssRule('.tb-rename-icon', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(FieldRenameIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
});

cssRule('.tb-rename-icon:hover, .tb-rename-icon:focus', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(FieldRenameIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#333333'))})`,
});

cssRule('.tb-run-now-icon', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(PlayCircleIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
});

cssRule('.tb-run-now-icon:hover, .tb-run-now-icon:focus', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(PlayCircleIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#333333'))})`,
});

cssRule('.tb-refresh-icon', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(StatusRefreshIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
});

cssRule('.tb-refresh-icon:hover, .tb-refresh-icon:focus', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(StatusRefreshIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#333333'))})`,
});

cssRule('.tb-rename-editable-text-icon', {
    paddingLeft: '31px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '6px center',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(FieldRenameIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
    backgroundSize: '17px 17px',
});

cssRule('.tb-rename-editable-text-icon:hover, .tb-rename-editable-text-icon:focus', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(FieldRenameIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#333333'))})`,
});

cssRule('.tb-link-datasource, .tb-link-flow, .tb-link-user, .tb-link-view, .tb-link-workbook', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    paddingLeft: '23px',
});

cssRule('.tb-link-datasource, .tb-grid-icon-datasource', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(DatasourceCanBaseIconRaw, 16)})`,
});

cssRule('.tb-grid-icon-datasource, .tb-grid-icon-flow, .tb-grid-icon-user, .tb-grid-icon-view, .tb-grid-icon-view-attached-pdf, .tb-grid-icon-view-attached-all, .tb-grid-icon-workbook, .tb-grid-icon-workbook-attached-pdf, .tb-grid-icon-workbook-attached-all', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    width: '23px',
    height: '37px',
});

cssRule('.tb-grid-icon-datasource.tb-grid-icon-small-row, .tb-grid-icon-flow.tb-grid-icon-small-row, .tb-grid-icon-user.tb-grid-icon-small-row, .tb-grid-icon-view.tb-grid-icon-small-row, .tb-grid-icon-view-attached-pdf.tb-grid-icon-small-row, .tb-grid-icon-view-attached-all.tb-grid-icon-small-row, .tb-grid-icon-workbook.tb-grid-icon-small-row, .tb-grid-icon-workbook-attached-pdf.tb-grid-icon-small-row, .tb-grid-icon-workbook-attached-all.tb-grid-icon-small-row', {
    height: '26px',
});

cssRule('.tb-link-flow, .tb-grid-icon-flow', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(FlowBaseIconRaw, 18)})`,
});

cssRule('.tb-grid-icon-schedule-stylish', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    width: '23px',
    height: '44px',
    backgroundSize: '17px 17px',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(CalendarBaseIconRaw, 18)})`,
});

cssRule('.tb-grid-icon-site-stylish', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundSize: '20px 20px',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(SitesBaseIconRaw, 20)})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    width: '26px',
    height: '44px',
});

cssRule('.tb-link-user, .tb-grid-icon-user', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(UserSingleBaseIconRaw, 18)})`,
});

cssRule('.tb-link-view, .tb-grid-icon-view', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(TableauFileViewBaseIconRaw, 16)})`,
});

cssRule('.tb-link-workbook, .tb-grid-icon-workbook', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(TableauFileWorkbookBaseIconRaw, 16)})`,
});

cssRule('.tb-grid-icon-view-attached-pdf', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(FilePdfPaperclipIconRaw, 18)})`,
});

cssRule('.tb-grid-icon-view-attached-all', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(TableauFileViewPaperclipIconRaw, 16)})`,
});

cssRule('.tb-grid-icon-workbook-attached-pdf', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(FilePdfPaperclipIconRaw, 18)})`,
});

cssRule('.tb-grid-icon-workbook-attached-all', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(TableauFileWorkbookPaperclipIconRaw, 16)})`,
});

cssRule('.tb-icon-datasource-icon, .tb-icon-datasource-embedded, .tb-icon-datasource-published, .tb-icon-datasource-connection-file, .tb-icon-datasource-connection-external, .tb-icon-datasource-connection-tableau', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    width: '23px',
    height: '37px',
});

cssRule('.tb-icon-datasource-embedded', {
    backgroundSize: '17px 17px',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(DatasourceCanEmbeddedIconRaw, 18)})`,
});

cssRule('.tb-icon-datasource-published', {
    backgroundSize: '17px 17px',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(DatasourceCanBaseIconRaw, 18)})`,
});

cssRule('.tb-icon-datasource-connection-file', {
    backgroundSize: '17px 17px',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(FileBaseIconRaw, 18)})`,
});

cssRule('.tb-icon-datasource-connection-external', {
    backgroundSize: '17px 17px',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(DatasourceServerConnectionBaseIconRaw, 14)})`,
});

cssRule('.tb-icon-datasource-connection-tableau', {
    backgroundSize: '17px 17px',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(DatasourceCanBaseIconRaw, 16)})`,
});

cssRule('.tb-icon-process-status', {
    display: 'inline-block',
    width: '21px',
    height: '20px',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
});


cssRule('.tb-status-legend-item', {
    marginRight: '12px',
});

cssRule('.tb-status-legend-item .tb-icon-process-status', {
    display: 'inline-block',
    height: '23px',
    marginRight: '3px',
});

cssRule('.tb-row-with-icon-on-right', {
    display: 'inline-flex',
    paddingRight: '29px',
    position: 'relative',
});

cssRule('.tb-row-icon-on-right', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 'auto',
    width: '23px',
    height: '23px',
    backgroundPosition: 'center center',
});

cssRule('.tb-row-icon-on-right-react', {
    position: 'absolute',
    top: '-5px',
    right: 0,
    bottom: 0,
    left: 'auto',
    width: '23px',
    height: '23px',
    backgroundPosition: 'center center',
});

cssRule('.tb-header-row-icon', {
    height: '35px',
    backgroundPosition: 'center center',
});

cssRule('.tb-header-row-icon-centered', {
    backgroundPosition: 'center center',
    padding: '0px 10px 0px 30px',
    boxSizing: 'border-box',
    height: '24px',
});

cssRule('.tb-dropdown-label-icon-on-right', {
    marginLeft: '3px',
    padding: '0px 2px 2px 0px',
});

cssRule('.tb-white-icon-permissions-locked', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(LockSolidIconRaw, 18, applyColor(DesignTokens.color.icon.default.light, '#FFFFFF'))})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    height: '19px',
    width: '19px',
});

cssRule('.tb-white-icon-permissions-unlocked', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(LockUnlockedOutlineIconRaw, 18, applyColor(DesignTokens.color.icon.default.light, '#FFFFFF'))})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    height: '19px',
    width: '19px',
});

cssRule('.tb-white-icon-permissions-mixed', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: 'url(img/locked_mixed_white_normal.svg?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    height: '19px',
    width: '19px',
});

cssRule('.tb-gray-icon-permissions-locked', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(LockSolidIconRaw, 18, applyColor(DesignTokens.color.icon.default.disabled, '#C0C0C0'))})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    height: '19px',
    width: '19px',
});

cssRule('.tb-gray-icon-permissions-unlocked', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(LockUnlockedOutlineIconRaw, 18, applyColor(DesignTokens.color.icon.default.disabled, '#C0C0C0'))})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    height: '19px',
    width: '19px',
});

cssRule('.tb-gray-icon-permissions-mixed', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: 'url(img/locked_mixed_gray_normal.svg?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    height: '19px',
    width: '19px',
});

cssRule('.tb-section-open-icon', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '19px',
    height: '19px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(ArrowTriangleRightIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
});

cssRule('.tb-section-open-icon:hover', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(ArrowTriangleRightIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#333333'))})`,
});

cssRule('.tb-section-close-icon', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '19px',
    height: '19px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(ArrowTriangleLeftIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
});

cssRule('.tb-section-close-icon:hover', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(ArrowTriangleLeftIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#333333'))})`,
});

cssRule('.tb-dialogs-workbook', {
    display: 'inline-block',
    verticalAlign: 'top',
    height: '17px',
    width: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(TableauFileWorkbookBaseIconRaw, 16)})`,
    paddingLeft: '3px',
});

cssRule('.tb-dialogs-warning', {
    display: 'inline-block',
    verticalAlign: 'top',
    height: '17px',
    width: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationAlertWarningShieldSolidIconRaw, 16)})`,
    paddingLeft: '3px',
});

cssRule('.tb-data-pane-workbook-icon, .tb-data-pane-datasource-icon, .tb-data-pane-datasource-extract-icon, .tb-data-pane-datasource-cube-icon, .tb-prep-flow-icon', {
    height: '17px',
    width: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/published_type_workbook.png?1_0_9606_yabs0uv7t1h)',
    paddingLeft: '3px',
});

cssRule('.tb-data-pane-datasource-extract-icon', {
    backgroundImage: 'url(img/published_type_datasource_extract.png?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-data-pane-datasource-cube-icon', {
    backgroundImage: 'url(img/published_type_datasource_cube.png?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-prep-flow-icon', {
    backgroundImage: 'url(img/published_type_flow.png?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-prep-flow-overview-history-status-icon, .tb-prep-flow-overview-history-status-pending-icon, .tb-prep-flow-overview-history-status-inprogress-icon, .tb-prep-flow-overview-history-status-success-icon, .tb-prep-flow-overview-history-status-failed-icon, .tb-prep-flow-overview-history-status-cancelled-icon, .tb-prep-flow-overview-run-now-icon', {
    display: 'inline-block',
    verticalAlign: 'middle',
    backgroundSize: '17px 17px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    width: '23px',
    height: '37px',
});

cssRule('.tb-prep-flow-overview-history-status-pending-icon', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(StatusInProgressIconRaw, 18)})`,
});

cssRule('.tb-prep-flow-overview-history-status-inprogress-icon', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(StatusRefreshIconRaw, 18)})`,
});

cssRule('.tb-prep-flow-overview-history-status-success-icon', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(StatusActiveIconRaw, 18)})`,
});

cssRule('.tb-prep-flow-overview-history-status-failed-icon', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(StatusErrorIconRaw, 18)})`,
});

cssRule('.tb-prep-flow-overview-history-status-cancelled-icon', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationAlertWarningShieldSolidIconRaw, 18)})`,
});

cssRule('.tb-prep-flow-overview-run-now-icon', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(PlayCircleIconRaw, 18, applyColor(DesignTokens.color.icon.default.default, '#666666'))})`,
});

cssRule('.tb-published-connection-policies-applied', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundSize: '17px 17px',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(ShieldBaseIconRaw, 18)})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    width: '23px',
    height: '37px',
});

cssRule('.tb-published-connection-policies-applied-metadata', {
    backgroundRepeat: 'no-repeat',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(ShieldBaseIconRaw, 18)})`,
    backgroundPosition: 'left center',
});

cssRule('.tb-icon-process-status-active', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(StatusActiveIconRaw, 20)})`,
});

cssRule('.tb-icon-process-status-busy', {
    backgroundImage: 'url(img/node-status-busy-animated.gif?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-status-legend-item > .tb-icon-process-status-busy', {
    backgroundImage: 'url(img/node-status-busy.png?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-process-status-down', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(StatusDownIconRaw, 20)})`,
});

cssRule('.tb-icon-process-status-passive', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(StatusActiveIconRaw, 20)})`,
});

cssRule('.tb-icon-process-status-unlicensed', {
    backgroundImage: 'url(img/node-status-unlicensed.png?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-process-status-external', {
    backgroundImage: 'url(img/node-status-external.png?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-process-status-statusnotavailable', {
    backgroundImage: 'url(img/node-status-unavailable.png?1_0_9606_yabs0uv7t1h)',
});

